/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import './BoxPort.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import { FormGroup, Input, Label } from 'reactstrap';

const ExternalAtaPorts = ({
  port,
  onPortSelect,
  selected,
  boxDetails,
  resetE911,
  assignE911ToPort,
}) => {
  const containerClassName = selected ? 'boxAtaPortContainer selected' : 'boxAtaPortContainer';
  const [e911Check, setE911Check] = useState(!!port?.e911Number);

  return (
    <div className={containerClassName}>
      <div
        onClick={ev => {
          ev.stopPropagation();
          onPortSelect(port);
        }}
      >
        <div className="portLabel">{port?.boxPortNumber}</div>
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="signature" />
            <h5>Service Name</h5>
          </div>
          <span>{(port.assignedNumberRef && port.assignedNumberRef.type) || 'Unassigned'}</span>
        </div>
        <div className="portInfo">
          <div className="infoLabel">
            <FontAwesomeIcon fixedWidth className="labelIcon" icon="hashtag" />
            <h5>Assigned Number</h5>
          </div>
          <span className="date">
            {(port.assignedNumberRef && port.assignedNumberRef.number) || 'There is no number'}
          </span>
        </div>
      </div>
      <div>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input
              type="checkbox"
              checked={port?.e911Enabled}
              disabled
              onChange={() => {
                setE911Check(!e911Check);
                if (e911Check) {
                  resetE911(port);
                } else {
                  assignE911ToPort(port);
                }
              }}
            />
            E911 Enabled
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input type="checkbox" checked={!!port?.vmNumber} disabled />
            Voice Mail
          </Label>
        </FormGroup>
        <FormGroup hidden={boxDetails.myEpik} className="port-checkbox">
          <Label check>
            <Input disabled type="checkbox" checked={port?.forceForward} />
            Forward
          </Label>
        </FormGroup>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  boxDetails: state.AppState.boxDetails.box,
});

export default connect(
  mapStateToProps,
  null,
)(ExternalAtaPorts);
